import {
    ClipboardCopyButton,
    CodeBlock,
    CodeBlockAction,
    CodeBlockCode,
} from '@patternfly/react-core';
import React from 'react';

import { ExclamationCircleIcon } from '@patternfly/react-icons';

export interface ErrorStateProps {
    title: string;
    children?: string | React.ReactNode;
}

const LoadingError: React.FunctionComponent<ErrorStateProps> = ({ title, children }) => {

    const [copied, setCopied] = React.useState(false);

    const clipboardCopyFunc = async (text: string) => {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text.toString());
      } else {
        const ta = document.createElement('textarea');
        ta.value = text.toString();
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
    };

    const onClick = (event, text) => {
      clipboardCopyFunc(text)
        .then(() => setCopied(true))
        .catch(() => setCopied(false));
    };

    const actions = (
        <React.Fragment>
          <CodeBlockAction>
            <ClipboardCopyButton
              id="basic-copy-button"
              textId="code-content"
              aria-label="Copy to clipboard"
              onClick={(e) => onClick(e, children)}
              exitDelay={copied ? 1500 : 600}
              maxWidth="110px"
              variant="plain"
              onTooltipHidden={() => setCopied(false)}
            >
              {copied ? 'Successfully copied to clipboard!' : 'Copy to clipboard'}
            </ClipboardCopyButton>
          </CodeBlockAction>
        </React.Fragment>
      );


      const devops_channel_link = <a target='_blank' rel='noreferrer' href='https://teams.microsoft.com/l/channel/19%3A28455b82a18945c6a862ce3998b57644%40thread.tacv2/DevOps%20Office%20Hours?groupId=634ca986-f9c6-40d1-912e-0a2cde365972&tenantId=c162a585-4fef-44bd-9271-d96409d0a349'>Devops Office Hours</a>
      const devsd_link = <a target='_blank' rel='noreferrer' href='https://devops.teladoc.net'>DEVSD for Service Request</a>

      return (
        <div className="dx-empty-state dx-empty-state--full">
            <div className="dx-empty-state__icon" style={{ color: 'var(--accent-red)' }}>
                <ExclamationCircleIcon />
            </div>
            <h4 className="dx-empty-state__title">{title}</h4>
            <div className="dx-empty-state__body">

                <p>
                    Please refresh the browser to try again.
                </p>
                <p>
                    If the issue persist or occurs often please post a message in the {devops_channel_link} or create a {devsd_link} including the message below.
                </p>

                <br />
                <CodeBlock actions={actions}><CodeBlockCode style={{textAlign: "left"}}>{children}</CodeBlockCode></CodeBlock>


            </div>
        </div>
    );
}

export default LoadingError;
